import React, { useContext, useEffect, useState } from 'react'
import { Card } from '../../../../components/ui/Card'
import { Button } from '../../../../components/ui/button'
import IconExport from '../../../../components/svg/IconExport'
import { useLocation, useParams } from 'react-router-dom';
// import { dateConvert } from '../../../../shared/common/dateFormate'
import { useDispatch, useSelector } from 'react-redux'
import { DatePickerCustomInput } from '../../../../components/ui/DatePickerCustomInput'

import { DataTableNew } from '../../../../components/table-components/data-table';
import moment from 'moment-js';
import { priceSubData } from '../../../../store/actions/admin/pricesAction';
import { Filters } from '../../../../constant';
import DataTableColumnHeader from '../../../../components/table-components/data-table-column-header';
const HistoricalTable = () => {

    const dispatch = useDispatch()
    const { pricesDetails } = useSelector(state => state)
    const { slug } = useParams();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [error, setError] = useState({});

    const location = useLocation();
    const stateData = location?.state.data

    const onChange = (filter) => {
        const data = {
            startDate: "",
            endDate: "",
            type: "raw",
            assetIds: [stateData?.data?._id],
            ...filter
        }
        dispatch(priceSubData(data))
    }

    const handleDateRangeClick = () => {
        if (startDate !== null && endDate !== null) {
            onChange({
                page: Filters.PAGE,
                perPage: Filters.OBJ.perPage,
                startDate: startDate === null ? '' : moment(startDate).format('YYYY-MM-DD'),
                endDate: endDate === null ? '' : moment(endDate).format('YYYY-MM-DD'),
                assetIds: [stateData?.data?._id]
            })
            setError({})
        } else {
            setError({ dataError: 'Please select date range!' })
        }
    }

    const handleReset = () => {
        setStartDate(null);
        setEndDate(null);
        setError({})
        onChange({
            page: Filters.PAGE,
            perPage: Filters.OBJ.perPage,
            startDate: null,
            endDate: null,
            assetIds: [stateData?.data?._id]
        })
    }

    const keyData = pricesDetails && pricesDetails?.records?.length ? pricesDetails?.records[0] : {};

    const keysName = Object.keys(keyData)
    // const data = pricesDetails && pricesDetails?.records?.length ? pricesDetails?.records.map((item, index) => {
    //     const keys = Object.keys(item)
    //     const values = Object.values(item)
    //     const obj = { ...Object.assign({}, ...keys.map((key, index) => ({ [key]: values[index] }))) };

    //     return obj
    // }) : []

    // const columns = keysName.length ? keysName.map((item) => {

    //     return {
    //         accessorKey: item,
    //         header: ({ column }) => (
    //             <DataTableColumnHeader className="capitalize" column={column} title={item} />
    //         ),
    //         cell: ({ row }) => {
    //             return (
    //             <div>{row.original[item]}</div>
    //         )},
    //         enableSorting: true,
    //     }

    // }) : [];
    const columns = [
        {
            accessorKey: "data",
            header: ({ column }) => (
                <DataTableColumnHeader className="capitalize" column={column} title={"Data"} />
            ),
            cell: ({ row }) => {
                return (
                    <div>{row.original?.data}</div>
                )
            },
            enableSorting: true,
        },
        {
            accessorKey: "value",
            header: ({ column }) => (
                <DataTableColumnHeader className="capitalize" column={column} title={"Value"} />
            ),
            cell: ({ row }) => {
                return (
                    <div>{row.original?.value}</div>
                )
            },
            enableSorting: true,
        }
    ] 

    const data = pricesDetails && pricesDetails?.records?.length > 0 ? pricesDetails?.records.map((price) => {


        return {
            data: new Date(price?.date)?.toLocaleDateString("en-GB",{
                month: '2-digit',
                day: '2-digit',
                year: 'numeric'
            }),
            value: price.value
        }
    
    }) : []


    return (

        <section className='p-2 md:px-5'>
            <Card className="bg-white p-3 md:p-5 ">
                <div className="card-head flex items-center gap-2 justify-between mb-4">
                    <h4 className='text-base font-600 text-textV2'>Historical Data</h4>
                </div>
                <div className="table-wrapper">
                    <div className="table-toolbar flex items-center justify-between gap-4 mb-6">
                        <div className="flex items-center gap-4">
                            <label htmlFor="" className='text-textV1 text-xs font-500'>
                                Time Period:
                            </label>
                            <div className="flex items-center gap-4 flex-wrap">
                                <div className="flex items-center gap-4">
                                    <label htmlFor="" className='text-textV1 text-xs font-500'>From</label>
                                    <DatePickerCustomInput onDateSelect={(date) => setStartDate(date)}
                                        placeholderText='YYYY-MM-DD'
                                        selectedFromDate={startDate}
                                        value={startDate}
                                    />
                                </div>
                                <div className="flex items-center gap-4">
                                    <label htmlFor="" className='text-textV1 text-xs font-500'>To</label>
                                    <DatePickerCustomInput onDateSelect={(date) => setEndDate(date)}
                                        placeholderText='YYYY-MM-DD'
                                        minDate={startDate}
                                        selectedFromDate={startDate}
                                        value={endDate}
                                    />

                                </div>
                                <Button size="sm" className="min-w-[98px] hover:bg-[#F5F5F5]" type="submit" variant="outline" disabled={startDate === null || endDate === null} onClick={handleReset}>
                                    {/*  */}
                                    Reset
                                </Button>
                                <Button size="sm" className="min-w-[98px] hover:bg-[#F5F5F5]" type="submit" variant="outline" disabled={startDate === null || endDate === null} onClick={() => handleDateRangeClick()}>
                                    {/*  */}
                                    Apply
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className="table-wrapper">
                        <DataTableNew data={data} columns={columns} onChange={onChange} isSearchHide={true} isCollViewHide={true} filterName={'Name'} isRight={true} />
                    </div>
                </div>
            </Card>
        </section>
    )
}

export default HistoricalTable
